// Mock data for KICRF Crypto Track

export const speakers = [
  {
    id: 1,
    name: "Олена Волкова",
    title: "Головний офіцер з інтелекту",
    company: "CipherChain Analytics",
    photo: "https://images.unsplash.com/photo-1579226905180-636b76d96082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxhbmFseXN0fGVufDB8fHx8MTc2MzMwNzQ5NHww&ixlib=rb-4.1.0&q=85",
    bio: "Експерт з блокчейн-форензики та виявлення криптозагроз"
  },
  {
    id: 2,
    name: "Маркус Чен",
    title: "Керівник OSINT операцій",
    company: "DarkNet Intel",
    photo: "https://images.unsplash.com/photo-1585900464046-f713a61424dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwZXhwZXJ0fGVufDB8fHxibGFja3wxNzYzMzA3NDU5fDA&ixlib=rb-4.1.0&q=85",
    bio: "Піонер цифрового спостереження та розвідки з відкритих джерел"
  },
  {
    id: 3,
    name: "Сара Мартінес",
    title: "Директор з кіберризиків",
    company: "SecureBlock Labs",
    photo: "https://images.pexels.com/photos/8108531/pexels-photo-8108531.jpeg",
    bio: "Спеціаліст з аномалій крипторинку та запобігання шахрайству"
  },
  {
    id: 4,
    name: "Олексій Петров",
    title: "Старший аналітик загроз",
    company: "BlockGuard Security",
    photo: "https://images.unsplash.com/photo-1589128560340-b66ae74e4fc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwZXhwZXJ0fGVufDB8fHxibGFja3wxNzYzMzA3NDU5fDA&ixlib=rb-4.1.0&q=85",
    bio: "Провідний експерт з безпеки DeFi та аудиту смарт-контрактів"
  },
  {
    id: 5,
    name: "Майя Шарма",
    title: "Головний науковий співробітник з даних",
    company: "CryptoSentinel AI",
    photo: "https://images.pexels.com/photos/6091649/pexels-photo-6091649.jpeg",
    bio: "ШІ-виявлення загроз та прогнозна аналітика"
  },
  {
    id: 6,
    name: "Віктор Козлов",
    title: "Керівник відділу інтелекту",
    company: "RedFlag Analytics",
    photo: "https://images.unsplash.com/photo-1627042013784-8483742812d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwZXhwZXJ0fGVufDB8fHxibGFja3wxNzYzMzA3NDU5fDA&ixlib=rb-4.1.0&q=85",
    bio: "Виявлення інсайдерських патернів та маніпуляцій ринком"
  },
  {
    id: 7,
    name: "Ліза Ванг",
    title: "Керівник блокчейн-форензики",
    company: "ChainTrace",
    photo: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxhbmFseXN0fGVufDB8fHx8MTc2MzMwNzQ5NHww&ixlib=rb-4.1.0&q=85",
    bio: "Відстеження криптозлочинних мереж та схем відмивання коштів"
  },
  {
    id: 8,
    name: "Джеймс Родрігез",
    title: "Віце-президент з досліджень безпеки",
    company: "CyberShield Global",
    photo: "https://images.pexels.com/photos/34734506/pexels-photo-34734506.jpeg",
    bio: "Провідні дослідження вразливостей Web3"
  }
];

export const topics = [
  {
    id: 1,
    title: "Інтелект загроз",
    description: "Передові методології виявлення та нейтралізації криптозагроз у реальному часі",
    icon: "AlertTriangle"
  },
  {
    id: 2,
    title: "Патерни криптошахрайства",
    description: "Виявлення та аналіз нових тактик шахрайства в криптовалютній екосистемі",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Ринкові аномалії на основі даних",
    description: "Використання передової аналітики для виявлення підозрілих торговельних патернів та маніпуляцій",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "ШІ в блокчейн-аналізі",
    description: "Застосування машинного навчання для он-чейн форензики та прогнозного моделювання загроз",
    icon: "Brain"
  },
  {
    id: 5,
    title: "Безпека CEX & DeFi",
    description: "Комплексні фреймворки безпеки для централізованих та децентралізованих бірж",
    icon: "Lock"
  },
  {
    id: 6,
    title: "Регуляторні виклики",
    description: "Навігація у викликах комплаєнсу та регуляторного тиску на глобальних крипторинках",
    icon: "Scale"
  },
  {
    id: 7,
    title: "OSINT фреймворки",
    description: "Інструменти та техніки розвідки з відкритих джерел для криптодослідження",
    icon: "Search"
  },
  {
    id: 8,
    title: "Інсайдерська сигналізація",
    description: "Виявлення та аналіз патернів інсайдерської торгівлі та витоку інформації",
    icon: "Eye"
  },
  {
    id: 9,
    title: "Моделі виявлення червоних прапорів",
    description: "Побудова автоматизованих систем раннього попередження крипторизиків та шахрайства",
    icon: "Flag"
  }
];

export const whyAttend = [
  "Доступ до неопублікованих ринкових досліджень та ексклюзивних аналізів",
  "OSINT методології від провідних розвідувальних агентств",
  "Закриті розслідування та кейс-стаді",
  "Високопосадовці урядів та експерти з кібербезпеки",
  "Лабораторії крипторизиків з практичними майстер-класами",
  "Нетворкінг з аналітиками, CEO та командами безпеки",
  "Раннє виявлення нових загроз та вразливостей",
  "Прямий доступ до інструментів блокчейн-форензики"
];

export const program = [
  {
    time: "09:00 - 10:00",
    title: "Реєстрація та ранкова кава",
    type: "networking"
  },
  {
    time: "10:00 - 10:30",
    title: "Відкриваюча доповідь: Стан криптозагроз 2026",
    speaker: "Олена Волкова",
    type: "keynote"
  },
  {
    time: "10:30 - 12:00",
    title: "Панель: ШІ-OSINT для блокчейну",
    type: "panel"
  },
  {
    time: "12:00 - 13:00",
    title: "Обід та нетворкінг",
    type: "break"
  },
  {
    time: "13:00 - 14:30",
    title: "Майстер-клас: Виявлення червоних прапорів у DeFi",
    type: "workshop"
  },
  {
    time: "14:30 - 16:00",
    title: "Кейс-стаді: Великі криптодослідження",
    type: "session"
  },
  {
    time: "16:00 - 16:30",
    title: "Перерва на каву та виставка",
    type: "break"
  },
  {
    time: "16:30 - 18:00",
    title: "Завершальна панель: Майбутнє криптобезпеки",
    type: "panel"
  },
  {
    time: "18:00 - 20:00",
    title: "VIP-прийом та приватний нетворкінг",
    type: "networking"
  }
];

export const partners = [
  {
    id: 1,
    name: "Google",
    logo: "https://images.ctfassets.net/6od8mvrv1bsg/3bcx474Pf9YHkZBmW7brpm/a39c6973406891df5ed01d58d5b6a69b/01-google-12.svg",
    tier: "platinum"
  },
  {
    id: 2,
    name: "CrowdStrike",
    logo: "https://images.ctfassets.net/6od8mvrv1bsg/6WuVBBRQdHMSDtlknbXrxY/cb8af5b929b940819947c2323edf8c06/04-crowdstrike-10.svg",
    tier: "platinum"
  },
  {
    id: 3,
    name: "Kyivstar",
    logo: "https://images.ctfassets.net/6od8mvrv1bsg/4DnJZHySHJlWGZXz9sRqRJ/83517162ef17a4c0175d5d8b1b290c23/03-kyivstar-14.svg",
    tier: "gold"
  },
  {
    id: 4,
    name: "PUMB",
    logo: "https://images.ctfassets.net/6od8mvrv1bsg/4Ku2PC3NYHYyqeRNQ6e9Cw/3e9d7254f7993528ef10f484d27fd2a3/09-pumb-10.svg",
    tier: "gold"
  },
  {
    id: 5,
    name: "Fortinet",
    logo: "https://images.ctfassets.net/6od8mvrv1bsg/6JgNyEbuU8CRzIe9Px61EB/621ec18ebe76c1d93deffd2dba1814d8/07-fortinet-16.svg",
    tier: "silver"
  },
  {
    id: 6,
    name: "Thales",
    logo: "https://images.ctfassets.net/6od8mvrv1bsg/1oM59XNmCYFe9UCIynQlp9/a8dc315b2eaa2d223a88e83e350bb13a/15-thales-10.svg",
    tier: "silver"
  }
];

export const venue = {
  city: "Київ",
  country: "Україна",
  venue: "Закрита локація",
  address: "Точна адреса буде оголошена за 3 дні до події",
  date: "19 лютого 2026",
  image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.0.3&q=85&w=1920",
  isSecret: true,
  secretInfo: "З міркувань безпеки точна локація буде розкрита лише відібраним учасникам за 3 дні до початку"
};
